import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Meu nome é Yan Christoffer e sou , brasileiro, atualmente Consultor Node na DQRTech , formado em Técnico em Informática pela UFV-Florestal e Graduado em Ciência da Computação pela Faculdade Pitágoras-Betim. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Amante de tecnologia, entusiasta de novas linguagens, biblioteca e frameworks. Desenvolvedor principalmente PHP e JavaScript porém conheço também diversas outras linguagens e ferramentas. participante frequente de eventos e comunidades de desenvolvimento. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Meu modo atual de trabalho é como Full Cycle Developer, participando, liderando e definindo desde o planejamento de estruturação da Engenharia de Software e Solução até ao deploy da aplicação alcançando partes de desenvolvimento full stack e também a gerencia de infraestrutura ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "mx-auto rounded-pill",
            "max-width": "350",
            height: "400",
            image: 'img/yan.jpeg',
            title: "Yan",
            theme: "dark"
          }, null, 8, ["image"]),
          _hoisted_1,
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}